import baseHttpService from "core/http/singleton/base";

import {
  ActionVoteRes,
  getEventsRes,
  getProfileCandidateRes,
  VoteResultRes,
  getProgramsRes,
  getVotesRes,
  getDetailEventRes,
  getDetailProgramRes,
} from "./resTypes";

import {
  getEventsUrl,
  getProfileCandidateURL,
  getVoteResultURL,
  handleVoteURL,
  getProgramsUrl,
  getVotesUrl,
  getDetailEventsUrl,
  getDetailProgramUrl,
  getPostRemainURL,
} from "./urls";

import {
  getDetailEventParams,
  getDetailProgramParams,
  getEventsParams,
  getVoteResultParams,
  getProgramsParams,
  getVotesParams,
  getPostIgnoreTopParams,
} from "./paramsTypes";

export const getEventsApi = async (
  payload: getEventsParams
): Promise<getEventsRes> => {
  const params = payload;
  const res = await baseHttpService.get<getEventsRes>(getEventsUrl(), params);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getDetailEventsApi = async (
  payload: getDetailEventParams
): Promise<getDetailEventRes> => {
  const { eventId } = payload;
  const res = await baseHttpService.get<getDetailEventRes>(
    getDetailEventsUrl(eventId)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getProgramsApi = async (
  payload: getProgramsParams
): Promise<getProgramsRes> => {
  const params = payload;
  const res = await baseHttpService.get<getProgramsRes>(
    getProgramsUrl(),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getProfileCandidateApi = async (
  id: string
): Promise<getProfileCandidateRes> => {
  const res = await baseHttpService.get<getProfileCandidateRes>(
    getProfileCandidateURL(id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
export const getDetailProgramApi = async (
  payload: getDetailProgramParams
): Promise<getDetailProgramRes> => {
  const { programId } = payload;
  const res = await baseHttpService.get<getDetailProgramRes>(
    getDetailProgramUrl(programId)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const handleVoteApi = async ({ postId }): Promise<ActionVoteRes> => {
  const res = await baseHttpService.post<ActionVoteRes>(handleVoteURL, {
    postId,
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getVoteResultApi = async (
  payload: getVoteResultParams
): Promise<VoteResultRes> => {
  const params = payload;
  const res = await baseHttpService.get<VoteResultRes>(
    getVoteResultURL,
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
export const getVotesApi = async (
  payload: getVotesParams
): Promise<getVotesRes> => {
  const params = payload;
  const res = await baseHttpService.get<getVotesRes>(getVotesUrl(), params);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getPostRemainApi = async (
  payload: getPostIgnoreTopParams
): Promise<VoteResultRes> => {
  const { topLimit, ...params } = payload;
  const res = await baseHttpService.get<VoteResultRes>(
    getPostRemainURL(topLimit),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
